import { type FC, useMemo } from "react";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import ContactUsForm from "~/features/contactUs/components/ContactUsForm";
import ContactUsSidebar from "~/features/contactUs/components/ContactUsSidebar";
import { Col, Row } from "~/common/components/Layout";
import { useTranslation } from "react-i18next";
import { Alert } from "~/common/mui/Alert/Alert";

export interface ContactUsDisplayProps {
  subjects: string[];

  titles: {
    label: string;
    value: string;
  }[];

  salutations: {
    label: string;
    value: string;
  }[];

  user: {
    salutation: string;
    title: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
  };

  salesRepresentative: {
    fullAddress: string;
  };

  contactImageSrc?: string;

  serverError?: string;
}

export const ContactUsPage: FC<ContactUsDisplayProps> = (props) => {
  const { t } = useTranslation();
  const subjects = useMemo(() => {
    return props.subjects.map((subject) => ({
      label: t(subject),
      value: subject,
    }));
  }, [props.subjects]);

  return (
    <>
      <PageTitle title={t("contactUsPage.title")} />

      {props.serverError && (
        <Alert severity="error" className="mb-3">
          {t(props.serverError)}
        </Alert>
      )}

      <Row>
        <Col size={8}>
          <ContactUsForm {...props} subjects={subjects} />
        </Col>

        <Col size={4}>
          <ContactUsSidebar fullAddress={props.salesRepresentative.fullAddress} imageSrc={props.contactImageSrc} />
        </Col>
      </Row>
    </>
  );
};

export function createContactUsPage(data: ContactUsDisplayProps) {
  return <ContactUsPage {...data} />;
}
